/* @flow */
import React, { type Node } from 'react';
import type { TNews } from '../../types/helpful';
import { ArticleDate, ArticleItem, ArticleTitle } from './styles';
import Link from '../../components/Link';

type TProps = {
	item: TNews,
};

const News = ({ item }: TProps): Node => {
	const date = new Date(item?.createdAt.replace(' ', 'T'));

	return (
		<ArticleItem>
			<ArticleTitle>
				<Link to={`/news/${item.slug}/`}>{item.title}</Link>
			</ArticleTitle>
			<ArticleDate>
				{date.toLocaleString('ru-RU', {
					day: 'numeric',
					month: 'long',
					year: 'numeric',
				})}
			</ArticleDate>
		</ArticleItem>
	);
};

export default News;
